import MultipleSelectionEditor from '../MultipleSelectionEditor';
import React from 'react';
import { SelectionCardView } from './SelectionCardView';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { SingleSelectionEditor } from '../SingleSelectionEditor';
import { useLessonContext } from '../../../models/LessonContext';

export const SelectionCard = (props: SelectionComponentProps) => {
  const { mode } = useLessonContext();

  const isSingle = props.component.type === 'single_selection_card';

  return mode === 'edit' ? (
    isSingle ? (
      <SingleSelectionEditor component={props.component} hasImage={true} />
    ) : (
      <MultipleSelectionEditor component={props.component} hasImage={true} />
    )
  ) : (
    <SelectionCardView {...props} />
  );
};
